import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M19.164 15.96a1.807 1.807 0 0 1 0 2.638c-.352.351-.82.527-1.289.527-.527 0-.996-.176-1.348-.527l-6.152-6.153-6.21 6.153c-.353.351-.821.527-1.29.527-.527 0-.996-.176-1.348-.527a1.807 1.807 0 0 1 0-2.637L7.68 9.75 1.527 3.598a1.807 1.807 0 0 1 0-2.637 1.807 1.807 0 0 1 2.637 0l6.211 6.152L16.527.961a1.807 1.807 0 0 1 2.637 0 1.807 1.807 0 0 1 0 2.637l-6.152 6.21z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }